import { render, staticRenderFns } from "./BoxSelectFile.vue?vue&type=template&id=6b2855fc&scoped=true&"
import script from "./BoxSelectFile.vue?vue&type=script&lang=js&"
export * from "./BoxSelectFile.vue?vue&type=script&lang=js&"
import style0 from "./BoxSelectFile.vue?vue&type=style&index=0&id=6b2855fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2855fc",
  null
  
)

export default component.exports